// extracted by mini-css-extract-plugin
export default {"stick":"style_stick__ICS4P","text":"style_text__0S-Ca","btns":"style_btns__jeRS7","backgroundContainer":"style_backgroundContainer__8MsWL"};